export default __webpack_public_path__ + "static/media/linkedin.bb933d68.png";